import React, { useState } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useTranslation } from 'react-i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { ActionButton, Icon, IconButton, TooltipHost, TooltipOverflowMode, css, mergeStyleSets } from "@fluentui/react";
import SidePanelContractInformation from './SidePanelContractInformation';

const SG3_HEADER = (props) => {
const { t } = useTranslation();
const { 
	inputParam_HideHeader = false,
	inputParam_ComponentContent = null,
    inputParam_UseFake = false,
	inputParam_BoardStructure = null,
    inputParam_Container = null
} = props;

const [infoObject, setInfoObject] = useState({
	id: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].id : 0) : 0,
	name: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].name : '') : 'Servicio de transporte terrestre de personal',
	contractCode: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].contractCode : '') : '4540003974',
	eecc: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].eecc : '') : 'TANDEM S.A.',
	nRevisions: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].nRevisions : '') : '0',
	roles: !inputParam_UseFake ? (inputParam_ComponentContent !== null ? inputParam_ComponentContent.items[0].l_roles : '') : []
});

const [isPanelContractInformationOpen, setIsPanelContractInformationOpen] = useState(false);

const circleStyle = {
	width: "55px",
	height: "55px",
	backgroundColor: "grey",
	borderRadius: '50%',
	padding: '10px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	fontSize: '12px'
};
const classNames = mergeStyleSets({
	overflow: {
	  overflow: 'hidden',
	  textOverflow: 'ellipsis',
	},
	parent: {
	  selectors: { '> *:last-child': { marginTop: 10 } },
	},
});

const handlerOpenMoreInformationPanel = () => {
	setIsPanelContractInformationOpen(!isPanelContractInformationOpen)
}
	
const renderContent = () => {
	return <>
				<Row className='py-2 me-1' style={{height: "25%", opacity: inputParam_UseFake ? ".4" : ""}}>
					<Col xl={2} className='text-center my-auto'><Icon iconName='Articles' style={{fontSize: "52px"}} /></Col>
					<Col xl={10} className='col-auto my-auto'>
						<Row>
							<Col style={{fontSize: "24px", fontWeight: "bolder"}}>{infoObject.contractCode}</Col>
						</Row>
						<Row>
							<Col className='col-auto me-1' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
								<TooltipHost
									overflowMode={TooltipOverflowMode.Self}
									content={infoObject.name}
								>
									<div style={{fontSize: "18px", fontWeight: "bolder"}}>{infoObject.name}</div>
								</TooltipHost>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row className='py-2 me-1' style={{height: "15%", opacity: inputParam_UseFake ? ".4" : ""}}>
					<Col xl={2} className='text-center my-auto' style={{display: "ruby"}}>
						<div style={circleStyle}>
							<div style={{ fontWeight: "bold", color: "white" }}>EECC</div>
						</div>
					</Col>
					<Col xl={10} className='col-auto my-auto'>
					{infoObject.eecc}
					</Col>
				</Row>
				<Row className='py-2 me-1' style={{height: "15%", opacity: inputParam_UseFake ? ".4" : ""}}>
					<Col xl={2} className='text-center my-auto'style={{display: "ruby"}}>
						<div style={circleStyle}>
							<div style={{ fontWeight: "bold", color: "white" }}>
								<Icon iconName="NumberSymbol" style={{ fontSize: "22px", fontWeight: "bold", color: "white" }} />
							</div>
						</div>
					</Col>
					<Col xl={10} className='col-auto my-auto'>
					{infoObject.nRevisions} {t('data-lang-lbl-reviews')}
					</Col>
				</Row>
				<Row className='me-1' style={{height: "40%", overflowY: "scroll"}}>
					<Col>
					{
						(infoObject && infoObject.roles) && infoObject.roles.map((role, index) => (
							<Row key={index} className='py-2 me-1' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
								<Col xl={2} className='text-center my-auto'style={{display: "ruby"}}>
									<div style={circleStyle}>
										<div style={{ fontWeight: "bold", color: "white" }}>{role.role}</div>
									</div>
								</Col>
								<Col xl={10} className='col-auto my-auto' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
									<TooltipHost
										overflowMode={TooltipOverflowMode.Self}
										content={ `${role.firstname} ${role.lastname} (${role.username})` }
										hostClassName={css(classNames.overflow)}
										onTooltipToggle={false}
										styles={{
											root: { display: 'block' },
										}}
									>
										{ `${role.firstname} ${role.lastname} (${role.username})` }
									</TooltipHost>
								</Col>
							</Row>
						))
					}
					</Col>
				</Row>
			</>
}

return (
		<>
			{
				!inputParam_UseFake &&
				<Card className='board-element-form h-100'>
					{
						!inputParam_HideHeader &&
						<Card.Header className="card-header-compact">
							<Card.Title className="d-flex justify-content-between">
								<b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-contractinformation')) : t('data-lang-boxname-contractinformation')}</b>
								<div className='toolbar d-flex'>
									<HEADER_TOOLBAR inputParam_BoardStructure={inputParam_BoardStructure} inputParam_Container={inputParam_Container} />
								</div>
								<ActionButton text='Más' onClick={handlerOpenMoreInformationPanel} iconProps={{iconName: "View"}} styles={{ icon: { fontSize: 20 } }} />
							</Card.Title>
						</Card.Header>
					}
					<Card.Body className='px-2 pt-2 h-95'>
						{renderContent()}
					</Card.Body>
					{
						isPanelContractInformationOpen && infoObject.id !== 0 &&
						<SidePanelContractInformation
							isPanelOpen={ isPanelContractInformationOpen }
							setterIsPanelOpen={ setIsPanelContractInformationOpen } 
							contractId={infoObject.id}
						/>
					}
				</Card>
			}
			{
				inputParam_UseFake && renderContent()
			}
		</>

)};

export default SG3_HEADER;